<!-- 公共積替一覧 -->
<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-transfer
          </v-icon>
          公共積替
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>
      <v-col class="text-right">
        <v-btn
          color="primary"
          :disabled="isJwMode"
          @click="addButtonClickEvent"
        >
          公共積替の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat>
          <v-data-table
            :headers="tableHeaders"
            :items="public_places"
            :items-per-page="-1"
            disable-sort
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.name`]="{ item }">
              <span :title="item.name">{{ item.name | truncate(20) }}</span>
            </template>

            <template v-slot:[`item.address`]="{ item }">
              <span :title="item.address">{{ item.address | truncate(20) }}</span>
            </template>

            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="showButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-file-document-outline
                </v-icon>
                <span v-else>参照</span>
              </v-btn>
              <v-btn
                :disabled="isJwMode"
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-note-edit
                </v-icon>
                <span v-else>
                  編集
                </span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
export default {
  name: 'DriverMasterTransshipmentIndex',
  components: {
    CustomPagination,
    Confirm
  },
  filters: {
  },
  mixins: [
  ],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      tableHeaders: [
        { text: 'コード', value: 'code' },
        { text: '事業場名', value: 'name' },
        { text: '郵便番号', value: 'zip_code' },
        { text: '所在地', value: 'address' },
        { text: '詳細・編集', value: 'editable', align: 'end' },
      ],
      public_places: []
    }
  },
  computed: {
    ...mapState('DriverMasterPublicPlace', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isJwMode: 'use_jw_mode',
    }),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchPublicPlaces()
  },
  methods: {
    ...mapActions('DriverMasterPublicPlace', {
      fetchPublicPlaces: 'index',
      deletePublicPlaces: 'destroy',
      resetPagination: 'resetPagination',
    }),

    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$router.push({name: 'DriverMasterPublicPlaceNew'})
    },
    /**
     * 参照ボタン クリックイベント
     * @param item { Object }
     */
     showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterPublicPlace', params: { id: item.id }})
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterPublicPlaceEdit', params: { id: item.id }})
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deletePublicPlaces({ id: item.id }).then(() =>{
            this.searchPublicPlaces()
          })
        }
      })
    },
    changePage(page) {
      this.page = page;
      this.searchPublicPlaces()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchPublicPlaces()
    },
    searchPublicPlaces () {
      let params = {
        page: this.page,
        limit: this.perPage
      }
      this.fetchPublicPlaces(params).then((content) => {
        this.public_places = content.public_places
      })
    },
  }
}
</script>

<style scoped>

</style>
